import { Locale } from '@synergy/models';

import { getCurrencySymbol } from './get-currency-symbol';

export const getSuffixCurrency = (value: number | null, currency: string, locale: Locale): string | undefined => {
    return value == null ? undefined : ` ${getCurrencySymbol(currency, locale)}`;
};
